<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" lg="12">
                <v-card flat outlined>
                    <v-card-title>
                        {{ $t('labels.applied') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="applicationsTable.additionalFilters"
                                    :default-sort="applicationsTable.defaultSort"
                                    :excel="true"
                                    :fields="applicationsTable.headers"
                                    :total-records="applicationsTable.total"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                    height="300px"
                                    :showFooter="true"
                                    :showIcons="true"
                                >
                                    <tr
                                        v-for="(item, key) in applicationsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(item.id, true)"
                                    >
                                        <td
                                            v-if="applicationsTable.selectedHeaders.includes('seafarer')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.seafarer_display }}
                                        </td>
                                        <td
                                            v-if="applicationsTable.selectedHeaders.includes('date_applied')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.date_applied_display }}
                                        </td>
                                        <td
                                            v-if="applicationsTable.selectedHeaders.includes('status')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.application_status_display }}
                                        </td>
                                        <td class="text-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'VacancyApplications',
    components: {TheTable},
    data: function () {
        return {
            applicationsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.seafarer'), value: 'seafarer', type: '', sortable: false},
                    {text: this.$t('fields.dateApplied'), value: 'date_applied', type: '', sortable: false},
                    {text: this.$t('fields.status'), value: 'status', type: '', sortable: false},
                    {
                        text: this.$t('fields.actions'),
                        value: 'actions',
                        type: '',
                        sortable: false,
                        width: '100px',
                        allowFilter: false,
                    },
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'id',
                    descending: true,
                },
            },
        };
    },
    props: ['vacancy'],

    methods: {
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/applications/' + id);
            } else {
                let routeData = this.$router.resolve('/applications/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.applicationsTable.selectedHeaders = headers;
        },

        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall(
                'get',
                'vacancy-applications/' + this.vacancy.id,
                request,
                (data, success) => {
                    if (success) {
                        vm.applicationsTable.items = data.items;
                        vm.applicationsTable.total = data.total;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'applications',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/applications', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
    },
};
</script>

<style scoped></style>
